import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
    auctioneerDataTemplatePropertiesType,
    auctioneerDataTemplatesType,
    sortingParamType,
} from '../../types';
import SortControl from '../SortControl';
import AuctioneerDataTemplateRow from './AuctioneerDataTemplateRow';

AuctioneerDataTemplatesList.propTypes = {
    auctioneerDataTemplates: auctioneerDataTemplatesType.isRequired,
    auctioneerDataTemplateProps: auctioneerDataTemplatePropertiesType.isRequired,
    onSort: PropTypes.func.isRequired,
    onUpload: PropTypes.func.isRequired,
    sortingParam: sortingParamType.isRequired,
};

function AuctioneerDataTemplatesList(props) {
    const {
        auctioneerDataTemplates,
        auctioneerDataTemplateProps,
        onSort,
        onUpload,
        sortingParam,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="auctioneer-data-templates-list">
            <div className="rich-list-row rich-list-header auctioneer-data-templates-list--header">
                <div className="rich-list-row--arrow-mobile" />
                <div className="auctioneer-data-template-header--values--id">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="id">
                        {t('auctioneer-data-templates.list-header.id')}
                    </SortControl>
                </div>
                <div className="auctioneer-data-template-header--values--name">
                    <SortControl onChange={onSort} sortingParam={sortingParam} sortingKey="name">
                        {t('auctioneer-data-templates.list-header.name')}
                    </SortControl>
                </div>
                <div className="rich-list-row--arrow" />
            </div>
            {
                auctioneerDataTemplates.length
                    ? auctioneerDataTemplates.map((auctioneerDataTemplate) => (
                        <AuctioneerDataTemplateRow
                            auctioneerDataTemplate={auctioneerDataTemplate}
                            auctioneerDataTemplateProps={auctioneerDataTemplateProps}
                            onUpload={onUpload}
                            key={auctioneerDataTemplate.id}
                        />
                    ))
                    : (
                        <div className="auctioneer-data-templates-no-items">
                            {t('auctioneer-data-templates.no-items')}
                        </div>
                    )
            }
        </div>
    );
}

export default AuctioneerDataTemplatesList;
